import { Grid } from "@mui/material";
import GKTable from "components/GKTable";

const Admins = () => {
  const columns = [
    {
      headerName: "Admin Name",
      field: "name",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Company Name",
      field: "comapnyname",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Phone Number",
      field: "phone",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Created On",
      field: "createdon",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
  ];

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <GKTable
          columns={columns}
          maxHeight={"calc(100vh - 250px)"}
          searchPlaceholder="Search for Admin"
          filterButton={false}
        />
      </Grid>
    </Grid>
  );
};

export default Admins;
